<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__wrapper">
        <div class="footer__images">
          <img src="@images/visaSecureLogo.svg" alt="visa secure logo">
          <img src="@images/mastercardLogo.svg" alt="mastercard logo">
        </div>
        <nav class="footer__nav">
          <router-link class="footer__nav-item" :to="translations.i18nRoute({ name: 'faq' })">F.A.Q</router-link>
          <router-link class="footer__nav-item" :to="translations.i18nRoute({ name: 'policy' })">{{ t('footer.nav.privacy') }}</router-link>
          <router-link class="footer__nav-item" :to="translations.i18nRoute({ name: 'terms' })">{{ t('docs.terms.title') }}</router-link>
        </nav>
        <div class="footer__images">
          <img src="@images/visaSecureLogo.svg" alt="visa secure logo">
          <img src="@images/mastercardLogo.svg" alt="mastercard logo">
        </div>
      </div>
    </div>
    <div class="footer__bottom">
      <div class="container">
        <p class="footer__bottom-text">2025 © {{ companyName }}. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import {useCompanyStore} from "@/stores/company.js";
import {computed} from "vue";
import translations from "@/core/helpers/translations.js";
import {useI18n} from "vue-i18n";

const {t} = useI18n()
const companyStore = useCompanyStore()

const companyName = computed(() => {
  if (!companyStore.companyInfo?.companyName) return '';
  const [text] = companyStore.companyInfo.companyName.split(',').map((part) => part.trim());
  return text;
});
</script>

<style lang="scss" scoped>
.footer {
  background-color: #262b22;
  
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-block: 40px;
  }

  &__images {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  &__nav {
    display: flex;
    align-items: center;
    gap: 20px;

    &-item {
      transition: 0.2s;
      cursor: pointer;
      font-size: 20px;
      color: $white;

      @include hover {
        color: #737373;
      }
    }
  }

  &__bottom {
    background-color: $main;
    padding-block: 15px;

    &-text {
      text-align: center;
      color: $white;
    }
  }
}

@media (max-width: 700px) {
  .footer {
    &__wrapper {
      flex-direction: column;
      gap: 50px;
    }
  }
}

@media (max-width: 500px) {
  .footer {
    &__nav {
      flex-direction: column;
    }
  }
}
</style>